import { handleActions } from 'redux-actions';
import endpoints from '../../../config/endpoints';
import http from '../../shared/http';
import intl from '../../shared/intl';
import cloneDeep from 'lodash/cloneDeep';

const TOGGLE_PROGRESS_BAR = 'tickets/toggle-progress-bar';

const FETCH_MANAGER_DATA_SUCCESS = 'tickets/fetch-manager-data-success';
const FETCH_MANAGER_DATA_ERROR = 'tickets/fetch-manager-data-error';

const initialState = {
	showProgressBar: false,
	error: null,
	showPromocodeForm: false
};
// actions
export const actions = {
	fetchManager: () => (dispatch, getState) => {

		const request = http({
			url: endpoints.PROFILE.MANAGER,
			method: 'get',
			actions: [FETCH_MANAGER_DATA_SUCCESS, FETCH_MANAGER_DATA_ERROR]
		});
		return dispatch(request);
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	})
};

const reducers = Object.assign(
	{
		[TOGGLE_PROGRESS_BAR]: state => ({
			...state, showProgressBar: !state.showProgressBar
		}),
		[FETCH_MANAGER_DATA_SUCCESS]: (state, action) => ({
			...state, manager: action.payload.data
		}),
		[FETCH_MANAGER_DATA_ERROR]: state => ({
			...state, error: true
		})
	}
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getIntl: state => intl(state),
	getManager: state => state.managerPopup.manager || {},
	getUser: state => state.app && state.app.userData,
	getError: state => state.managerPopup.error
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/manager-popup/index.js